import { defaultCtx } from "~/lib/AjaxCtx"
import { buildQueryString } from "~/lib/utils"

export default class FinderService {
    constructor(ctx = defaultCtx) {
        this.$http = ctx
    }

    async fetchItems({ searchText, itemType, cursor }) {
        let url = "/finder"
        if (searchText) {
            searchText = searchText.replace(/\//g, " ")
            const cleanSearchText = encodeURIComponent(searchText)
            url += `/${cleanSearchText}`
        }
        if (itemType) {
            url += `/${encodeURIComponent(itemType)}`
        }
        const qs = buildQueryString({ cursor })
        if (qs) {
            url += `?${qs}`
        }

        const {
            data: items,
            meta: {
                cursor: { next: nextCursor },
            },
        } = await this.$http.fetchAPI(url)

        return { items, nextCursor }
    }
}
